import { createAction, props } from '@ngrx/store';
import { ItemsPagination } from 'src/app/model/api/data-rest';
import { PaginationParams } from 'src/app/model/api/pagination-params';

import { Ticket } from 'src/app/model/ticket';


export const getTickets = createAction('GET_TICKETS', props<{
    paging?: PaginationParams;
    filter?: string;
    flagClosed?: number;
}>());
export const getTicketsSuccess = createAction('GET_TICKETS_SUCCESS', props<{ paging: ItemsPagination; tickets: Ticket[] }>());
export const getTicketsFailed = createAction('GET_TICKETS_FAILED', props<{ errorMessage: string }>());

export const getAllTickets = createAction('GET_ALL_TICKETS');
export const getAllTicketsSuccess = createAction('GET_ALL_TICKETS_SUCCESS', props<{ tickets: Ticket[] }>());
export const getAllTicketsFailed = createAction('GET_ALL_TICKETS_FAILED', props<{ errorMessage: string }>());

export const getTicket = createAction('GET_TICKET', props<{ id: number }>());
export const getTicketSuccess = createAction('GET_TICKET_SUCCESS', props<{ ticket: Ticket }>());
export const getTicketFailed = createAction('GET_TICKET_FAILED', props<{ errorMessage: string }>());

export const startAddTicket = createAction('TICKET_START_ADD');
export const addTicket = createAction('ADD_TICKET', props<{ ticket: Ticket }>());
export const addTicketSuccess = createAction('ADD_TICKET_SUCCESS', props<{ message: string }>());
export const addTicketFailed = createAction('ADD_TICKET_FAILED', props<{ errorMessage: string }>());

export const startCloseTicket = createAction('TICKET_START_CLOSE');
export const closeTicket = createAction('CLOSE_TICKET', props<{ ticket: Ticket }>());
export const closeTicketSuccess = createAction('CLOSE_TICKET_SUCCESS', props<{ message: string }>());
export const closeTicketFailed = createAction('CLOSE_TICKET_FAILED', props<{ errorMessage: string }>());
